import { IState } from "store/index";

export const isAppLoadedSelector = (state: IState) =>
  state.app.core.isAppLoaded;

export const currentUserSelector = (state: IState) => state.app.core.user;
